<template>
  <div :class="classnames" @click="handleClick">
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'popup-area'

  const modifiers = {
    isVisible: 'is-visible'
  }

  export default {
    name: 'PopupArea',
    mixins: [ bem ],
    props: {
      isVisible: {
        default: false,
        type: Boolean
      }
    },
    data: function () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      classnameModifiers: function () {
        const isVisible = this.isVisible && modifiers.isVisible

        return [ isVisible ]
      },
      handleClick: function (event) {
        event.stopPropagation()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Popup/PopupArea.vue